// English-keyed Spanish translations.
// Lookup is by the exact English string used in code (so missing keys fall back gracefully).

export const ES = {
  // Top utility bar
  "Pay Online": "Pagar en línea",
  "Refer a Patient": "Referir un paciente",

  // Navbar
  "Home": "Inicio",
  "Services": "Servicios",
  "Facial Aesthetics": "Estética Facial",
  "Facial Aesthetic": "Estética Facial",
  "About": "Nosotros",
  "About us": "Nosotros",
  "Meet the Doctors": "Conoce a los Doctores",
  "Office Tour": "Recorrido por la Oficina",
  "Patient Resources": "Recursos para Pacientes",
  "Financial Options": "Opciones Financieras",
  "Contact": "Contacto",
  "Contact us": "Contáctanos",
  "Reviews": "Reseñas",
  "Request Appointment": "Solicitar Cita",
  "Book Visit": "Reservar Visita",
  "Call": "Llamar",

  // Hero
  "We accept all PPO · Virginia · West Virginia Medicaid":
    "Aceptamos todos los PPO · Medicaid de Virginia · West Virginia",
  "Leesburg · Virginia · Est. Care": "Leesburg · Virginia · Atención Especializada",
  "Discover": "Descubre",
  "your": "tu",
  "smile.": "sonrisa.",
  "One-on-one dentistry in a family atmosphere. Drs. Yopa, Ide Noumy and Ebrahimi take the time you need — and tailor every treatment to the smile in front of them.":
    "Odontología personalizada en un ambiente familiar. Los Dres. Yopa, Ide Noumy y Ebrahimi se toman el tiempo que necesitas — y adaptan cada tratamiento a la sonrisa que tienen enfrente.",
  "Loved by Loudoun families": "Familias de Loudoun nos aman",
  "Multilingual care · EN · FR · فارسی · ES": "Atención multilingüe · EN · FR · فارسی · ES",
  "Exam · X-Rays · Cleaning": "Examen · Rayos X · Limpieza",
  "Inside Smiles of Loudoun": "Dentro de Smiles of Loudoun",
  "A family atmosphere,": "Un ambiente familiar,",
  "truly": "verdaderamente",
  "Tour our office": "Visita nuestra oficina",
  "Unmute": "Activar sonido",
  "Mute": "Silenciar",

  // Affiliations
  "Proud members of": "Miembros orgullosos de",
  "Multilingual team · English · French · Farsi · Spanish":
    "Equipo multilingüe · Inglés · Francés · Farsi · Español",

  // Services section (home)
  "Discover Our Refreshing Care": "Descubre Nuestro Cuidado Refrescante",
  "Helping you reach your": "Te ayudamos a alcanzar tu",
  "dream": "soñada",
  "From a routine cleaning to a full smile redesign — everything done under one warm roof, by doctors who actually pick up the phone.":
    "Desde una limpieza de rutina hasta un rediseño completo de la sonrisa — todo bajo un mismo techo cálido, por doctores que sí contestan el teléfono.",
  "See all services": "Ver todos los servicios",
  "Also offering BOTOX® · JUVÉDERM® · Pediatric care":
    "También ofrecemos BOTOX® · JUVÉDERM® · Odontología pediátrica",

  // About / Doctors
  "Meet your dentists": "Conoce a tus dentistas",
  "Discover dental": "Descubre la",
  "expertise": "experiencia",
  "expertise.": "experiencia dental.",
  "Three doctors. Four languages. One belief — that great dentistry starts with great conversation. We slow down so your treatment speeds up.":
    "Tres doctores. Cuatro idiomas. Una creencia — que la gran odontología comienza con una gran conversación. Vamos despacio para que tu tratamiento avance rápido.",
  "Dentist": "Dentista",

  // Features
  "Featured Care": "Atención Destacada",
  "Straighten your smile,": "Endereza tu sonrisa,",
  "invisibly.": "invisiblemente.",
  "Invisalign® clear aligners gently shift your teeth into place without the wires, brackets or 'I'm in braces' announcement. Custom-made for your bite, swapped every 1–2 weeks, removable for meals and brushing.":
    "Los alineadores transparentes Invisalign® mueven suavemente tus dientes a su lugar sin alambres, brackets ni el anuncio de \"estoy con frenos\". Hechos a la medida de tu mordida, se cambian cada 1–2 semanas y son removibles para comer y cepillarte.",
  "Learn about Invisalign": "Conoce Invisalign",
  "Request consult": "Solicitar consulta",
  "Discover Your Brilliance": "Descubre Tu Brillo",
  "BOTOX® and JUVÉDERM® —": "BOTOX® y JUVÉDERM® —",
  "subtle": "sutil",
  ", refreshed.": ", renovado.",
  "The same precise hands that craft your smile can soften lines around it. Dr. Yopa offers facial aesthetic treatments designed to complement — never compete with — your natural features.":
    "Las mismas manos precisas que crean tu sonrisa pueden suavizar las líneas a su alrededor. El Dr. Yopa ofrece tratamientos de estética facial diseñados para complementar — nunca competir con — tus rasgos naturales.",
  "Explore facial aesthetics": "Explorar estética facial",
  "$129 New Patient Special": "Oferta $129 para Nuevos Pacientes",

  // Special Offer
  "New patient special": "Oferta para nuevos pacientes",
  "Comprehensive Exam · Digital X-Rays · Cleaning":
    "Examen Completo · Rayos X Digitales · Limpieza",
  "A relaxed, no-rush first visit. We listen, we explain, and we build a plan that fits your life — not the other way around.":
    "Una primera visita relajada y sin prisas. Escuchamos, explicamos y diseñamos un plan que se adapta a tu vida — no al revés.",
  "Claim Offer": "Reclamar Oferta",

  // Testimonials
  "What patients say": "Lo que dicen los pacientes",
  "Quiet words.": "Palabras suaves.",
  "Loud": "Sonrisas",
  "smiles.": "radiantes.",
  "5.0 average · hundreds of reviews":
    "5.0 en promedio · cientos de reseñas",
  "Read more reviews": "Leer más reseñas",
  "5.0 on Google": "5.0 en Google",
  "Hundreds of verified reviews from real Leesburg families.":
    "Cientos de reseñas verificadas de familias reales de Leesburg.",
  "Read all on Google": "Ver todas en Google",
  "Leave a review": "Deja una reseña",
  "Verified Google review": "Reseña verificada en Google",

  // Gallery
  "Inside the office": "Por dentro de la oficina",
  "Discover your": "Descubre tu",
  "best": "mejor",
  "smile, truly.": "sonrisa.",
  "A warm, family-style space with the technology you'd expect from a specialty clinic — quietly tucked out of sight.":
    "Un espacio cálido y familiar con la tecnología que esperarías de una clínica especializada — discretamente fuera de la vista.",

  // Final CTA
  "Let's get your smile on": "Empieza tu sonrisa",
  "Join our": "Únete a nuestra",
  "dental": "familia",
  "family.": "dental.",
  "Schedule your visit online in under a minute, send us a quick note, or call us — we love actually picking up the phone.":
    "Agenda tu visita en menos de un minuto, envíanos un mensaje rápido o llámanos — nos encanta contestar el teléfono.",
  "Send a Message": "Enviar un Mensaje",
  "Address": "Dirección",
  "Languages": "Idiomas",
  "Hours": "Horarios",
  "Monday": "Lunes",
  "Tuesday": "Martes",
  "Wednesday": "Miércoles",
  "Thursday": "Jueves",
  "Friday": "Viernes",
  "Sat – Sun": "Sáb – Dom",
  "By Appointment": "Con cita previa",

  // Footer
  "Explore": "Explorar",
  "Visit": "Visítanos",
  "Family-first dentistry in Leesburg, Virginia. Proudly serving Ashburn, Broadlands, Belmont, Brambleton and neighboring cities in Northern Virginia.":
    "Odontología familiar en Leesburg, Virginia. Atendemos con orgullo Ashburn, Broadlands, Belmont, Brambleton y ciudades vecinas en el norte de Virginia.",
  "All rights reserved.": "Todos los derechos reservados.",
  "Crafted with care in Leesburg, VA":
    "Hecho con cariño en Leesburg, VA",

  // Contact form
  "Your name": "Tu nombre",
  "Email": "Correo electrónico",
  "Phone": "Teléfono",
  "Preferred time": "Horario preferido",
  "Service of interest": "Servicio de interés",
  "How can we help?": "¿Cómo podemos ayudarte?",
  "Any time": "Cualquier momento",
  "Weekday mornings": "Mañanas entre semana",
  "Weekday afternoons": "Tardes entre semana",
  "Evenings": "Noches",
  "Weekends": "Fines de semana",
  "I'm not sure — please advise": "No estoy seguro/a — por favor avísenme",
  "New patient cleaning & exam ($129)":
    "Limpieza y examen para nuevo paciente ($129)",
  "BOTOX® / JUVÉDERM®": "BOTOX® / JUVÉDERM®",
  "Other": "Otro",
  "Tell us a little about what you're looking for…":
    "Cuéntanos un poco lo que estás buscando…",
  "I consent to being contacted by Smiles of Loudoun about my inquiry. We never share your information.":
    "Acepto ser contactado/a por Smiles of Loudoun sobre mi consulta. Nunca compartimos tu información.",
  "Send Message": "Enviar Mensaje",
  "Sending…": "Enviando…",
  "Something went wrong. Please call us at 571-510-3034.":
    "Algo salió mal. Por favor llámanos al 571-510-3034.",
  "Thank you — we received your note.":
    "¡Gracias! Recibimos tu mensaje.",
  "A member of our team will reach out within one business day. For urgent care, call us directly at":
    "Un miembro de nuestro equipo se comunicará contigo en un día hábil. Para urgencias, llámanos directamente al",
  "Send another message": "Enviar otro mensaje",

  // Page heroes
  "Dental Care · Leesburg, VA": "Atención Dental · Leesburg, VA",
  "Comprehensive care,": "Atención integral,",
  "under one warm roof": "bajo un mismo techo cálido",
  "treatments organized into": "tratamientos organizados en",
  "care categories — every service we offer to families across Loudoun.":
    "categorías de atención — todos los servicios que ofrecemos a las familias de Loudoun.",
  "Don't see exactly what you're looking for? Give us a call at":
    "¿No ves exactamente lo que buscas? Llámanos al",
  "and we'll point you in the right direction.":
    "y te orientaremos en la dirección correcta.",

  // Services index
  "treatment": "tratamiento",
  "treatments": "tratamientos",

  // Service detail page chrome
  "← All services": "← Todos los servicios",
  "Request Consult": "Solicitar Consulta",
  "Why patients love": "Por qué los pacientes aman",
  "Frequently asked": "Preguntas frecuentes",
  "Questions,": "Preguntas,",
  "answered": "respondidas",
  "Ready to start?": "¿Listo para empezar?",
  "Let's talk about your": "Hablemos de tu",
  "Related care ·": "Atención relacionada ·",
  "Other treatments in": "Otros tratamientos en",
  "View all services": "Ver todos los servicios",

  // Financial Options
  "Financial Options · Leesburg, VA": "Opciones Financieras · Leesburg, VA",
  "Affordable dental care,": "Atención dental accesible,",
  "made simple": "sin complicaciones",
  "Costs should never be a concern when it comes to caring for your smile. We work with most PPO dental plans and offer flexible options to fit any budget.":
    "El costo nunca debe ser una preocupación al cuidar de tu sonrisa. Trabajamos con la mayoría de los planes dentales PPO y ofrecemos opciones flexibles para cualquier presupuesto.",
  "Insurance": "Seguro Dental",
  "We accept most PPO dental plans.":
    "Aceptamos la mayoría de los planes dentales PPO.",
  "Please contact our office before your visit to confirm your coverage, and remember to bring your insurance information with you to your appointment. We can help with filing your claim and finding ways to maximize your benefits.":
    "Por favor contacta nuestra oficina antes de tu visita para confirmar tu cobertura, y recuerda traer tu información de seguro a la cita. Te ayudaremos a presentar tu reclamo y a maximizar tus beneficios.",
  "We currently do not accept HMO insurance.":
    "Actualmente no aceptamos seguros HMO.",
  "You are responsible for any unpaid insurance balances over 45 days. If you are using insurance from an accident, full payment is due at the time of your visit — your insurance carrier will reimburse you after you file your claim.":
    "Eres responsable de cualquier saldo no pagado por el seguro después de 45 días. Si estás usando seguro de un accidente, el pago completo se realiza el día de la visita — tu aseguradora te reembolsará después de presentar el reclamo.",
  "Accepted for co-pays & out-of-pocket":
    "Aceptamos para co-pagos y gastos directos",
  "Pay your way.": "Paga a tu manera.",
  "Cash": "Efectivo",
  "Checks": "Cheques",
  "Credit Cards": "Tarjetas de Crédito",
  "Flexible Spending Accounts (FSA)":
    "Cuentas de Gastos Flexibles (FSA)",
  "Health Savings Accounts (HSA)":
    "Cuentas de Ahorro para la Salud (HSA)",
  "Patient financing": "Financiamiento para pacientes",
  "Flexible plans for": "Planes flexibles para",
  "every smile": "cada sonrisa",
  "For patients without insurance, we offer flexible payment plans and work with two leading financing partners. Apply in minutes — most decisions are instant.":
    "Para pacientes sin seguro, ofrecemos planes de pago flexibles y trabajamos con dos socios líderes en financiamiento. Aplica en minutos — la mayoría de las decisiones son instantáneas.",
  "Healthcare credit card with promotional financing. Use it for dental, vision, hearing and more — at thousands of providers nationwide.":
    "Tarjeta de crédito médica con financiamiento promocional. Úsala para dental, visión, audición y más — en miles de proveedores en todo el país.",
  "Buy-now-pay-later for healthcare. Pay over 3–24 months with 0% APR options. Soft credit check — no impact to your credit score.":
    "Compra-ahora-paga-después para salud. Paga en 3–24 meses con opciones a 0% APR. Verificación de crédito suave — sin impacto en tu puntaje.",
  "Apply →": "Aplicar →",
  "Questions about your coverage?": "¿Preguntas sobre tu cobertura?",
  "Call our team at": "Llama a nuestro equipo al",
  "and we'll walk you through your benefits and out-of-pocket costs before your visit.":
    "y te explicaremos tus beneficios y costos directos antes de tu visita.",

  // Facial Aesthetics
  "Facial Aesthetics · Leesburg, VA": "Estética Facial · Leesburg, VA",
  "Subtle, expert-administered facial aesthetics that complement — never compete with — your smile. The same precise hands that craft your dentistry can soften the lines around it.":
    "Estética facial sutil, administrada por expertos, que complementa — nunca compite con — tu sonrisa. Las mismas manos precisas que crean tu odontología pueden suavizar las líneas a su alrededor.",
  "Book a Consultation": "Reservar una Consulta",
  "What Are Facial Aesthetic Treatments?":
    "¿Qué son los tratamientos de estética facial?",
  "Noninvasive, natural,": "No invasivos, naturales,",
  "expertly placed": "aplicados con maestría",
  "Facial aesthetics encompass nonsurgical treatments that enhance facial appearance — creating a more youthful, balanced look that complements your smile. These treatments typically include noninvasive procedures targeting specific areas of the face, improving texture, smoothness and balance.":
    "La estética facial abarca tratamientos no quirúrgicos que mejoran la apariencia facial — creando un aspecto más joven y equilibrado que complementa tu sonrisa. Estos tratamientos típicamente incluyen procedimientos no invasivos dirigidos a áreas específicas del rostro, mejorando textura, suavidad y equilibrio.",
  "BOTOX® and dermal fillers like JUVÉDERM® work to reduce signs of aging (such as wrinkles or volume loss) and enhance features. While these treatments are cosmetic in nature, they can also provide additional comfort benefits — such as alleviating jaw tension in TMJ cases.":
    "BOTOX® y rellenos dérmicos como JUVÉDERM® reducen signos del envejecimiento (como arrugas o pérdida de volumen) y realzan los rasgos. Aunque estos tratamientos son de naturaleza cosmética, también pueden ofrecer beneficios adicionales — como aliviar la tensión mandibular en casos de TMJ.",
  "Provided by": "Realizado por",
  "The same precise hands that craft your smile. Personalized plans designed to feel like you — only more rested.":
    "Las mismas manos precisas que crean tu sonrisa. Planes personalizados diseñados para que sigas siendo tú — solo más descansado.",
  "Discover more": "Descubre más",
  "Two treatments,": "Dos tratamientos,",
  "infinite": "matices",
  "nuance.": "infinitos.",
  "Smooth lines · Soften expressions · Ease TMJ tension":
    "Suavizar líneas · Relajar expresiones · Aliviar tensión TMJ",
  "A precise neuromodulator used to relax targeted muscles that cause expression lines on the forehead, around the eyes and at the jawline. Delivered in tiny, expertly placed doses for natural movement.":
    "Un neuromodulador preciso que relaja los músculos que causan líneas de expresión en la frente, alrededor de los ojos y en la mandíbula. Aplicado en pequeñas dosis colocadas con experticia para mantener un movimiento natural.",
  "Restore volume · Define lips · Refine contours":
    "Restaurar volumen · Definir labios · Refinar contornos",
  "A family of hyaluronic acid dermal fillers that restore lost volume, refine lips, and contour cheeks and jawline. Results are immediate and naturally hydrated-looking.":
    "Una familia de rellenos dérmicos de ácido hialurónico que restauran volumen perdido, refinan labios y contornean mejillas y mandíbula. Los resultados son inmediatos y se ven naturalmente hidratados.",
  "Benefits": "Beneficios",
  "Subtle today.": "Sutiles hoy.",
  "Confident": "Con confianza",
  "for years.": "por años.",
  "Youthful Appearance": "Apariencia Juvenil",
  "Smooth fine lines and wrinkles to restore a more refreshed look.":
    "Suaviza líneas finas y arrugas para restaurar un aspecto más fresco.",
  "Harmonious Balance": "Equilibrio Armonioso",
  "Add subtle volume or soften lines to bring symmetry to your features.":
    "Añade volumen sutil o suaviza líneas para dar simetría a tus rasgos.",
  "Boosted Confidence": "Mayor Confianza",
  "Feel as good about your face as you do about your smile.":
    "Siéntete tan bien con tu rostro como con tu sonrisa.",
  "Quick, Nonsurgical": "Rápido, No Quirúrgico",
  "Most treatments are completed quickly with minimal downtime.":
    "La mayoría de los tratamientos se completan rápido y con mínima recuperación.",
  "Versatile Solutions": "Soluciones Versátiles",
  "Customized to the forehead, lips, jawline and TMJ relief.":
    "Personalizado para frente, labios, mandíbula y alivio del TMJ.",
  "Schedule your consultation": "Agenda tu consulta",
  "Tell us your": "Cuéntanos tus",
  "goals": "objetivos",
  "Personalized, professional care that helps you achieve a confident, radiant look tailored to your unique features.":
    "Atención personalizada y profesional que te ayuda a lograr un aspecto seguro y radiante, adaptado a tus rasgos únicos.",

  // Contact page
  "Contact · Leesburg, VA": "Contacto · Leesburg, VA",
  "Let's start a": "Iniciemos una",
  "conversation": "conversación",
  "Send us a quick note, give us a call, or stop by — whichever feels most like you. We respond within one business day.":
    "Envíanos un mensaje rápido, llámanos o pasa por la oficina — lo que prefieras. Respondemos en un día hábil.",
  "Reach us directly": "Contáctanos directamente",
  "Office hours": "Horario de oficina",
  "Request appointment online": "Solicitar cita en línea",
  "Refer a patient (PDF)": "Referir un paciente (PDF)",

  // Misc / language
  "English": "Inglés",
  "Spanish": "Español",

  // Doctor titles
  "General Dentist": "Dentista General",
  "Dental Anesthesiologist": "Anestesiólogo Dental",

  // Service categories (used in Services dropdown)
  "Cosmetic Dentistry": "Odontología Estética",
  "Restorative Dentistry": "Odontología Restaurativa",
  "Dental Implants": "Implantes Dentales",
  "General & Family Dentistry": "Odontología General y Familiar",
  "Oral Surgery": "Cirugía Oral",
  "Periodontics": "Periodoncia",
  "Sedation Dentistry": "Odontología con Sedación",

  // Patient Resources dropdown
  "Patient Forms": "Formularios de Paciente",
  "Patient Specials": "Ofertas para Pacientes",
  "New Patient Special": "Oferta Nuevo Paciente",

  // Facial Aesthetics dropdown
  "BOTOX® Treatments": "Tratamientos BOTOX®",
  "JUVÉDERM®": "JUVÉDERM®",

  // Local area / city landing pages
  "Serving": "Sirviendo",
  "A dentist your": "Un dentista para",
  "family will trust.": "confiar en tu familia.",
  "Neighbors we love": "Vecinos que amamos",
  "Care built around": "Cuidado creado para",
  "families.": "familias.",
  "Visit us from": "Visítanos desde",
  "Get directions": "Cómo llegar",
  "Popular in": "Popular en",
  "Treatments": "Tratamientos",
  "patients ask about most.": "que más piden nuestros pacientes.",
  "Learn more": "Más información",
  "Ready when you are": "Listos cuando tú lo estés",
  "Book your visit from": "Reserva tu visita desde",
  "Send us a note and we'll get you scheduled within one business day. Prefer to talk?":
    "Envíanos un mensaje y te agendaremos en un día hábil. ¿Prefieres hablar?",
  "Areas we serve": "Áreas que atendemos",
  "Dentist in": "Dentista en",

  // Blog / Insights
  "Insights": "Novedades",
  "Insights · Smiles of Loudoun": "Novedades · Smiles of Loudoun",
  "Smiles,": "Sonrisas,",
  "explained": "explicadas",
  "Small, honest dental tips from our team — preventive, cosmetic, and financial guidance in plain English.":
    "Pequeños y honestos consejos dentales de nuestro equipo — orientación preventiva, estética y financiera en lenguaje claro.",
  "min read": "min de lectura",
  "Read": "Leer",
  "All insights": "Todas las notas",
  "By": "Por",
  "Talk to our team": "Habla con nuestro equipo",
  "Have a question about this?": "¿Tienes una pregunta sobre esto?",
  "We're happy to answer questions in the chair — or by phone. No pressure, ever.":
    "Con gusto respondemos preguntas en el sillón — o por teléfono. Sin presión, nunca.",
  "More insights": "Más notas",
  "Keep": "Sigue",
  "reading": "leyendo",

  // Page titles & descriptions
  "Dentists in Leesburg, VA": "Dentistas en Leesburg, VA",
  "Family, cosmetic and implant dentistry in Leesburg, VA. Bilingual team led by Drs. Yopa, Ide Noumy & Ebrahimi. Book your visit — call 571-510-3034.":
    "Odontología familiar, estética e implantes en Leesburg, VA. Equipo bilingüe con los Dres. Yopa, Ide Noumy y Ebrahimi. Reserva tu visita — llama al 571-510-3034.",
  "Dental Services in Leesburg, VA": "Servicios dentales en Leesburg, VA",
  "Comprehensive dental care in Leesburg, VA — cosmetic, restorative, implants, oral surgery, periodontics, sedation and family dentistry.":
    "Atención dental integral en Leesburg, VA — estética, restaurativa, implantes, cirugía oral, periodoncia, sedación y odontología familiar.",
  "Financial Options & Insurance": "Opciones financieras y seguros",
  "Most PPO dental plans accepted. Flexible payment plans through CareCredit and Sunbit. Simple, transparent pricing at Smiles of Loudoun.":
    "Aceptamos la mayoría de planes PPO. Planes de pago flexibles con CareCredit y Sunbit. Precios simples y transparentes en Smiles of Loudoun.",
  "Contact Us": "Contáctanos",
  "Contact Smiles of Loudoun in Leesburg, VA. Call 571-510-3034 or send us a message — we respond within one business day.":
    "Contacta a Smiles of Loudoun en Leesburg, VA. Llama al 571-510-3034 o envíanos un mensaje — respondemos en un día hábil.",
  "Facial Aesthetics · BOTOX® & JUVÉDERM® in Leesburg, VA":
    "Estética Facial · BOTOX® y JUVÉDERM® en Leesburg, VA",
  "Expert-administered BOTOX® and JUVÉDERM® by Dr. Steve Yopa at Smiles of Loudoun in Leesburg, VA. Book your consultation.":
    "BOTOX® y JUVÉDERM® aplicados con maestría por el Dr. Steve Yopa en Smiles of Loudoun en Leesburg, VA. Reserva tu consulta.",
  "Insights · Dental Tips & Guides": "Novedades · Consejos y guías dentales",
  "Straight-talk dental tips from Drs. Yopa, Ide Noumy, and Ebrahimi at Smiles of Loudoun. Preventive care, cosmetic advice, and money-saving guides.":
    "Consejos dentales honestos de los Dres. Yopa, Ide Noumy y Ebrahimi en Smiles of Loudoun. Cuidado preventivo, orientación estética y guías para ahorrar.",
  "Admin": "Admin",
  "Restricted area.": "Área restringida.",

  // Exit-intent gift card popup
  "New Patient Offer": "Oferta Nuevo Paciente",
  "Wait — before you go": "Espera — antes de irte",
  "Get a": "Obtén una",
  "Amazon gift card.": "tarjeta de regalo Amazon.",
  "Book your first visit with Smiles of Loudoun. After your appointment, we'll email you a $20 Amazon eGift card as our thank-you.":
    "Reserva tu primera visita en Smiles of Loudoun. Después de tu cita, te enviaremos por correo una tarjeta de regalo Amazon de $20 como agradecimiento.",
  "New patients only. One gift per household.":
    "Solo nuevos pacientes. Un regalo por hogar.",
  "Reserve your gift below — we'll be in touch within one business day.":
    "Reserva tu regalo abajo — te contactaremos en un día hábil.",
  "Full name": "Nombre completo",
  "Reserving…": "Reservando…",
  "Reserve my gift card": "Reservar mi tarjeta de regalo",
  "No thanks, I'll pass": "No, gracias",
  "Couldn't send. Please call": "No se pudo enviar. Por favor llama al",
  "You're on the list.": "¡Estás en la lista!",
  "We opened our booking page in a new tab so you can pick your appointment time. After your visit, your $20 Amazon eGift card arrives by email.":
    "Abrimos nuestra página de reservas en una pestaña nueva para que elijas tu horario. Después de tu visita, tu tarjeta Amazon de $20 llegará por correo.",
  "Open booking page": "Abrir página de reservas",
  "Our team will reach out within one business day to schedule your first visit. Your $20 Amazon eGift card will arrive by email after your appointment.":
    "Nuestro equipo te contactará en un día hábil para agendar tu primera visita. Tu tarjeta Amazon de $20 te llegará por correo después de tu cita.",
  "Close": "Cerrar",
};

export const I18N = { es: ES };
